import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
};

export function Button({ children, variant = 'primary', className = '', ...props }: Props) {
  const base = 'focus-ring inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50';
  const styles = {
    primary: 'bg-charcoal text-warm hover:bg-cocoa',
    secondary: 'border border-charcoal/15 bg-warm text-charcoal hover:border-charcoal/30 hover:bg-bone',
    ghost: 'text-charcoal underline-offset-4 hover:underline'
  }[variant];
  return <button className={`${base} ${styles} ${className}`} {...props}>{children}</button>;
}
